import { mapItemDetails } from '../view-item/reducer';
import actionTypes from './action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SET_IS_LOADING:
            return { ...state, loading: action.payload };
        case actionTypes.SET_ITEM_DETAILS:
            return { ...state, itemDetails: mapItemDetails(action.payload) };
        case actionTypes.SET_PRODUCT:
            return { ...state, product: action.payload };
        default:
            return state;
    }
};
